import {assert} from 'assert-ts';
import {Concept} from 'types';
import type {ManifestationStatus} from 'api/types';
import type {ValidationResult} from 'schema/form/functions/validators/types';
import type {CodeListMap} from 'services/codelists/types';
import {getRestrictedManifestationCodelists} from 'schemas/codelistRestrictors/functions/getRestrictedManifestationCodelists';
import {getGetDataBasedSchemaModifiers} from 'schemas/functions';
import type {ExpressionV4, Metadata, MetadataSchemas, MetadataStatuses, WorkV4} from '../types';
import {validateEntity} from './validateEntity';

export const validateManifestation = (
  manifestationId: string,
  relatedScope: {work: WorkV4; expression: ExpressionV4},
  savedMetadata: Pick<Metadata, 'manifestations'>,
  metadata: Pick<Metadata, 'manifestations'>,
  schemas: MetadataSchemas,
  codelists: CodeListMap,
  statuses: MetadataStatuses,
): {validation: ValidationResult; status: ManifestationStatus} => {
  const savedManifestation = assert(
    savedMetadata.manifestations.find(m => m.id === manifestationId),
    'validateManifestation: saved manifestation not found',
  );
  const manifestation = assert(
    metadata.manifestations.find(m => m.id === manifestationId),
    'validateManifestation: manifestation not found',
  );

  const manifestaitonCodelists = getRestrictedManifestationCodelists(
    {...relatedScope, manifestation},
    codelists,
  );

  const getDataBasedModifier = getGetDataBasedSchemaModifiers(
    Concept.manifestation,
  );

  return validateEntity(
    savedManifestation,
    manifestation,
    relatedScope,
    relatedScope.work.type,
    statuses[manifestation.id],
    schemas.manifestation.schema,
    getDataBasedModifier,
    schemas.manifestation.modifiers,
    manifestaitonCodelists,
  );
};
